import React from 'react';
import './style.scss';
import { instanceOf } from 'prop-types';

function Wrapper({ children }) {
  return (
    <div className="mentors-section-wrapper">
      <div className="mentors-section arc-d-flex">{children}</div>
    </div>
  );
}

Wrapper.propTypes = {
  children: instanceOf(Object).isRequired,
};

export default Wrapper;
